import {
  getCheckInTalkingPointsApi,
  addCheckInTalkingPointsApi,
  updateCheckInTalkingPointsApi,
  deleteCheckInTalkingPointApi,
  getTalkingPointCommnentsApi,
  getGoalRecurrenceDetailsApi,
  updateGoalRecurrenceDetailsApi,
} from 'api/checkIn';

export const getCheckInTalkingPoints = async ({ orgId }) => {
  const res = await getCheckInTalkingPointsApi({ orgId });
  return res.entity;
};

export const addCheckInTalkingPoints = async ({ orgId, data }) => {
  const res = await addCheckInTalkingPointsApi({ orgId, data });
  return res.entity;
};

export const updateCheckInTalkingPoints = async ({ orgId, uuid, data }) => {
  const res = await updateCheckInTalkingPointsApi({ orgId, uuid, data });
  return res.entity;
};

export const deleteCheckInTalkingPoint = async ({ orgId, uuid }) => {
  const res = await deleteCheckInTalkingPointApi({ orgId, uuid });
  return res;
};

export const getTalkingPointComments = ({ parentId, startTS, endTS, limit, offset, questionId, scrollType }) =>
  getTalkingPointCommnentsApi({
    parentId,
    startTS,
    endTS,
    limit,
    offset,
    questionId,
    scrollType,
  }).then((res) => res.entity);

export const getGoalRecurrenceDetails = async ({ teamId }) => {
  const result = await getGoalRecurrenceDetailsApi({ teamId });
  return result.entity;
};

export const updateGoalRecurrenceDetails = async ({ teamId, recurrenceValue, recurrenceType }) => {
  const result = await updateGoalRecurrenceDetailsApi({
    teamId,
    recurrenceValue,
    recurrenceType,
  });
  return result.entity;
};
